export const replace = (conditionCheck, value, collection) => {
  return collection.map(item => (conditionCheck(item, value) ? value : item));
};

const replaceUtilities = {
  replace,
};

export default replaceUtilities;
